import { Injectable } from '@angular/core';
import { API_URL } from '../../shared/constants/apiurl-constants';
import { SessionService } from '../../shared/session-service/session.service';
import { BehaviorSubject, Subject } from 'rxjs';
import { EngagementListDto } from 'src/app/shared/models/engagement/engagement-list-dto';

@Injectable({
  providedIn: 'root'
})
export class StudyLandingService {
  engagementNumber: string;
  refreshTaxYear = new BehaviorSubject({});
  refreshStudyTaxYear = this.refreshTaxYear.asObservable();
  refreshFlag = new BehaviorSubject({});
  refreshStudyFlag = this.refreshFlag.asObservable();
  refreshPriorYearQre = new BehaviorSubject({});
  refreshEstimatedQre = new BehaviorSubject({});
  studyNavigation = new Subject<string>();

  private studyDetails = new BehaviorSubject<EngagementListDto>(null);
  studyDetails$ = this.studyDetails.asObservable();

  constructor(public sessionService: SessionService) { }

  getStudySummary(engagementId) {
    return this.sessionService.apiUrlGet(
      API_URL.GET_STUDY_SUMMARY + '?engagementId=' + engagementId,
    );
  }

 getEngagementQRE(engagementId) {
     return this.sessionService.apiUrlGet(
         API_URL.INSIGHTSGETQRE + '?engagementId=' + engagementId
    );
 }

  refreshStudyYear(taxYear) {
    this.refreshTaxYear.next(taxYear);
  }

  refreshStudyFlagId(engagementFlagId) {
    this.refreshFlag.next(engagementFlagId);
  }
  getStudyFlag() {
    return this.refreshFlag.asObservable();
  }

  refresPriorYearQREs(Qre) {
    this.refreshPriorYearQre.next(Qre);
  }

  refreshEstimatedQREs(Qre) {
    this.refreshEstimatedQre.next(Qre);
  }

  setStudyDetails(studyData: EngagementListDto): void {
    this.studyDetails.next(studyData);
  }
}
